import styled, { css, keyframes } from 'styled-components';
import { Button, lightenDarkenColor } from '../shared/utils/styles';

export const ButtonContainer = styled.div`
  & button {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 7px 12px;
    height: 50px;
    border: 1px solid gray;
    :disabled {
      cursor: not-allowed;
      background-color: #e7e7e7;
      color: #666;
    }
    & i {
      padding-right: 5px;
      font-size: 1.2em;
    }
  }
`;

export const MuteLaneMediaButton = styled(Button)`
  font-weight: normal;
  background-color: #0095E8;
  color: #fff;
  &:hover {
    background-color: ${lightenDarkenColor('#0095E8', 50)};
    color: #fff;
  }
`;

const blinker = keyframes`
  50% {
    opacity: 0;
  }
`;

const getBlinkingText = (blink) => {
  if (blink) {
    return css`
      animation: ${blinker} 0.5s linear infinite;
      -webkit-animation: ${blinker} 0.5s linear infinite;
    `;
  }
  return null;
};

export const BlinkingText = styled.span`
  ${(props) => getBlinkingText(props.blink)}
`;
